<template>
  <span 
    class="calico-navbar-item"
    :class="{ disabled }"
    v-bind="$attrs"
  >
    <slot />
  </span>
</template>

<script>
export default {
  name: "CalicoNavbarMenuItem",
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped lang="scss">
.calico-navbar-item {
  @include inline-space($space-small);
  align-items: baseline;
  cursor: pointer;
  color: $color-black;
  padding: $space-xsmall $space-small;
  border-radius: $radius-small;
  user-select: none;

  &:hover {
    background-color: $color-neutral-lightest;
  }
  
  &:active {
    background-color: $color-neutral-light;
  }
  
  &.disabled {
    pointer-events: none;
    color: $color-neutral-light;
    cursor: not-allowed;
  }
}
</style>
